import { styled } from 'linaria/react';

export const smallCaps = `
  font-style: normal;
  line-height: 1.5rem;
  font-size: 1.2rem;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  font-variant: small-caps;
  margin-bottom: 0.75rem;
`;
export const SmallCaps = styled('h1')`
  ${smallCaps};
`;
